// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.muzieknootjes {
  display: block;
  margin: auto;
  position: relative;
  width: 40px;
  height: 40px;
  border: 0px solid #000;
}

.noot-1,
.noot-2,
.noot-3,
.noot-4 {
  position: absolute;
  animation: notes 2s infinite linear;
  font-size: 35px;
  opacity: 0;
}

.noot-1 {
  bottom: 0px;
  left: 0;
  animation-delay: 0.5s;
  color: yellow;
}

.noot-2 {
  bottom: 0px;
  left: 30%;
  animation-delay: 1s;
  color: blue;
}

.noot-3 {
  bottom: 0px;
  left: 60%;
  animation-delay: 1.5s;
  color: green;
}

.noot-4 {
  bottom: 0px;
  left: 90%;
  animation-delay: 2s;
  color: red;
}

@keyframes notes {
  0% {
    transform: scale(1) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 1;
    transform: scale(1.5) translate(50%, -50%);
  }
  80% {
    opacity: 0;
    transform: scale(1.5) translate(100%, -100%);
  }
  100% {
    transform: scale(1.5) translate(100%, -100%);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Stream/musicNoteAnimation.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AACJ;;AAEA;;;;EAII,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,UAAA;AACJ;;AAEA;EACI,WAAA;EACA,OAAA;EACA,qBAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,SAAA;EACA,qBAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;AACJ;;AAEA;EACI;IACI,mCAAA;IACA,UAAA;EACN;EAEE;IACI,UAAA;IACA,0CAAA;EAAN;EAGE;IACI,UAAA;IACA,4CAAA;EADN;EAIE;IACI,4CAAA;IACA,UAAA;EAFN;AACF","sourcesContent":[".muzieknootjes {\n    display: block;\n    margin: auto;\n    position: relative;\n    width: 40px;\n    height: 40px;\n    border: 0px solid #000;\n}\n\n.noot-1,\n.noot-2,\n.noot-3,\n.noot-4 {\n    position: absolute;\n    animation: notes 2s infinite linear;\n    font-size: 35px;\n    opacity: 0;\n}\n\n.noot-1 {\n    bottom: 0px;\n    left: 0;\n    animation-delay: 0.5s;\n    color: yellow;\n}\n\n.noot-2 {\n    bottom: 0px;\n    left: 30%;\n    animation-delay: 1s;\n    color: blue;\n}\n\n.noot-3 {\n    bottom: 0px;\n    left: 60%;\n    animation-delay: 1.5s;\n    color: green;\n}\n\n.noot-4 {\n    bottom: 0px;\n    left: 90%;\n    animation-delay: 2s;\n    color: red;\n}\n\n@keyframes notes {\n    0% {\n        transform: scale(1) translate(0, 0);\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n        transform: scale(1.5) translate(50%, -50%);\n    }\n\n    80% {\n        opacity: 0;\n        transform: scale(1.5) translate(100%, -100%);\n    }\n\n    100% {\n        transform: scale(1.5) translate(100%, -100%);\n        opacity: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
